<script setup lang="ts">
import ArticleStock from '@/model/ArticleStock';

const props = defineProps({
  articleStock: {
    type: ArticleStock,
    required: true,
  },
});

defineExpose({
  articleStock: props.articleStock,
});
</script>

<template>
  <div v-if="articleStock">
    <v-list class="bg-grey-lighten-5 pa-0 overflow-hidden rounded elevation-1 mb-2 mt-3">
    <v-list-item append-icon="">
      <v-list-item-subtitle class="spread">
        <div>Bestellt</div>
        <div>Reserviert</div>
        <div>Auf Lager</div>
      </v-list-item-subtitle>
      <v-list-item-title class="spread mt-1 pa-3 pt-1">
        <div>
          <v-chip label variant="outlined" class="bestand-text">{{
              articleStock.MengeBestellt
            }}
          </v-chip>
        </div>
        <div>
          <v-chip label variant="outlined" class="bestand-text">
            {{ articleStock.MengeReserviert }}
          </v-chip>
        </div>
        <div>
          <v-chip label variant="outlined"
                  :color="articleStock.BestandPhysikalisch > 0 ? 'green' : 'red' "
                  class="bestand-text">
            <strong>{{ articleStock.BestandPhysikalisch }}</strong>
          </v-chip>
        </div>
      </v-list-item-title>
    </v-list-item>
    </v-list>
  </div>
</template>

<style scoped>
.bestand-text {
  font-size: 1.1rem;
}
</style>
